var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        center: "",
        "append-to-body": "",
        visible: _vm.dialogVisible,
        width: "30%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "lineBox" }, [
        _c("p", { staticClass: "lineBoxP1" }, [
          _c("i", { staticClass: "el-icon-info icon1" }),
          _vm._v("取消说明 "),
          _c("span", [_vm._v("*")]),
        ]),
        _c("p", [_vm._v("取消政策如下：")]),
        _c(
          "div",
          { staticClass: "cancelBox" },
          _vm._l(
            _vm.datas.modifyOrderCancelDetailResultList,
            function (item, index) {
              return _c("span", { key: index }, [
                _c("span", { staticClass: "cancelBoxSpan1" }, [
                  _vm._v(_vm._s(item.productName) + " "),
                ]),
                _vm._v(" " + _vm._s(item.cancellationPolicyDescription) + " "),
                item.cancelFees
                  ? _c("span", [
                      _vm._v("取消金额：" + _vm._s(item.cancelFees) + "¥"),
                    ])
                  : _vm._e(),
              ])
            }
          ),
          0
        ),
      ]),
      _c("div", { staticClass: "lineBox" }, [
        _c("p", { staticClass: "lineBoxP1" }, [
          _c("i", { staticClass: "el-icon-info icon1" }),
          _vm._v("取消原因"),
        ]),
        _c(
          "div",
          { staticClass: "titleBox" },
          _vm._l(_vm.titleList, function (item) {
            return _c("div", { key: item, staticClass: "titleBtn" }, [
              _vm._v(" " + _vm._s(item) + " "),
            ])
          }),
          0
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                content: "与商家沟通取消费用",
                placement: "bottom",
                effect: "light",
              },
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#ED7046" },
                  attrs: { size: "small" },
                  on: { click: _vm.cancelClick },
                },
                [_vm._v("取消订单")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }